import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { openNextQuest } from 'a/hub/actions/workshopActions';
import {
  DiamondProgress,
  WideGreenPanel,
  DescriptionText,
  ContinueButton,
  TitleText,
  HeaderText,
} from '../sharedComponents';
import useWorkshopSfx from '../../../hooks/useWorkshopSfx';

const QuestCompleteModal = ({ closeModal }) => {
  const dispatch = useDispatch();
  const headerText = 'Quest Complete!';

  const descriptionText =
    'You have unlocked a new quest! Get started powering up the transmitter and portal ' +
    'by playing a new set of Skill Games.';

  const { playTap, playSfxFromMap, audioMap } = useWorkshopSfx();

  useEffect(() => {
    playSfxFromMap(audioMap.quest_complete_launch);
  }, []);

  const onClick = (e) => {
    playTap(true);
    dispatch(openNextQuest());
    closeModal(e);
  };

  return (
    <div data-dd-action-name="workshop-quest-complete-modal">
      <WideGreenPanel data-testid="quest-complete-modal" />
      <TitleText data-testid="quest-complete-modal-title">SUCCESS</TitleText>
      <StyledContainer>
        <HeaderText style={{ width: 'inherit' }} data-testid="quest-complete-modal-message">
          {headerText}
        </HeaderText>
        <DescriptionText style={{ width: 'inherit' }} data-testid="quest-complete-modal-description">
          {descriptionText}
        </DescriptionText>
      </StyledContainer>
      <StyledDiamondProgress
        portalProgress={1}
        radioProgress={1}
        bookProgress={1}
        batteryProgress={1}
      />
      <ContinueButton onClick={onClick} data-dd-action-name="workshop-quest-complete-modal:continue" />
    </div>
  );
};

QuestCompleteModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  config: PropTypes.shape({
    questId: PropTypes.number,
  }).isRequired,
};

export default QuestCompleteModal;

const StyledDiamondProgress = styled(DiamondProgress)`
  top: 185px;
  left: 285px;
`;

const StyledContainer = styled.div`
  position: absolute;
  top: 177px;
  left: 480;
  height: 216px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 325;
`;
